import { createSlice } from '@reduxjs/toolkit';

const initialState: any = {
  // mainCategory : [],
 View_Cart : [],
 PickupAddress:[],
 SelectedPickupOptions:[],
 // Product ids the user chose to include in checkout from the Cart page.
 SelectedCartItems:[]
 
};

const Cart = createSlice({
  name: 'Cart',
  initialState,
  reducers: {
    VIEW_CART:(state, action)=>{
      state.View_Cart = action.payload;
    },
    Pickup_Address:(state, action)=>{
      state.PickupAddress = action.payload;
    },
    selected_pickup:(state, action)=>{
      state.SelectedPickupOptions = action.payload;
    },
    SET_SELECTED_CART_ITEMS:(state, action)=>{
      state.SelectedCartItems = action.payload;
    },
    CLEAR_CART:(state)=>{
      state.View_Cart = "";
      state.SelectedPickupOptions = [];
      state.SelectedCartItems = [];
    },
  },
});

export const { VIEW_CART,CLEAR_CART,Pickup_Address,selected_pickup,SET_SELECTED_CART_ITEMS } = Cart.actions;

export default Cart.reducer;